import Skeleton from "./skeleton";
import SkeletonAvatar from "./skeletonAvatar";
import SkeletonButton from "./skeletonButton";
import SkeletonImage from "./skeletonImage";
import SkeletonText from "./skeletonText";
Skeleton.name = 'Skeleton';
SkeletonAvatar.name = 'SkeletonAvatar';
SkeletonButton.name = 'SkeletonButton';
SkeletonImage.name = 'SkeletonImage';
SkeletonText.name = 'SkeletonText';
export {
  Skeleton,
  SkeletonAvatar,
  SkeletonButton,
  SkeletonImage,
  SkeletonText,
};
